import ServiceKfzAssignment from "../components/ServiceKfzAssignment";
import {connect} from "react-redux";
import mapValues from 'lodash/mapValues';
import {isOnline} from "../actions/userActions";
import {fetchKfzList, fetchKfzModels} from "../actions/kfzActions";
import {loadServices} from "../actions/serviceActions";
import {
	fetchServiceKfzStates,
	fetchServiceModelStates,
	removeServiceModelStates,
	updateServiceModelState
} from "../actions/service2kfzActions";
import {showSnackbar} from "../actions/snachbarActions";
import isFunc from 'lodash/isFunction';
import {makeRoute, ROUTE_SERVICE_DETAIL} from "../routes";
import {push} from 'react-router-redux';

const m2s = (state, props) => {
	const {service_id, kfz_id} = mapValues(props.match.params, id => Number(id));
	const kfz = state.kfz.list.find(k => k.kfz_id === kfz_id);
	const models = kfz ? kfz.models : undefined;
	const modelList = () => {
		try {return state.service2kfz.service_2_model[service_id][kfz_id];} catch(e){return {};}
	};
	return {
		service_id, kfz_id,
		kfz, models,
		service: state.service.list[service_id],
		service_list: state.service2kfz.service_2_kfz[service_id],
		service_model_list: modelList()
	};
};

const m2d = (dispatch, props) => {
	const {service_id, kfz_id} = mapValues(props.match.params, id => Number(id));
	dispatch(isOnline(() => {
		dispatch(fetchKfzList(kfz_id, false, () => {
			dispatch(fetchKfzModels(kfz_id));
		}));
		dispatch(loadServices());
		dispatch(fetchServiceKfzStates(service_id));
		dispatch(fetchServiceModelStates(service_id, kfz_id));
	}));
	return {
		onSaveModelStates: (data, onSuccess) => dispatch(updateServiceModelState(data, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service-kfz.models-updated'));
		})),
		onRemoveModelStates: (service, model_ids, onSuccess) => dispatch(removeServiceModelStates(service, model_ids, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.service-kfz.models-removed'));
		})),
		onBack: () => dispatch(push(makeRoute(ROUTE_SERVICE_DETAIL, {service_id})))
	};
};

export default connect(m2s, m2d)(ServiceKfzAssignment);


// WEBPACK FOOTER //
// ./src/containers/ServiceKfzAssignmentController.js